<template>
  <div class="listPage">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button
          class="addBtn"
          @click="showDialog()"
          v-if="null !== addPermission"
          >{{ addPermission.name }}</el-button>
      </div>
      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.keywords"
              placeholder="搜索用户名或手机号"
              @keyup.enter.native="handleCurrentChange(1)"
            >
              <!-- <div
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
          </div> -->
          <div slot="suffix" class="searchClass" @click="handleCurrentChange(1)">搜索</div>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        :height="tableHeight"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="userNo"
          label="账号"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="用户名"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="性别" align="center" min-width="15">
          <template slot-scope="scope">
            <span v-if="scope.row.sex == 1">男</span>
            <span v-if="scope.row.sex == 2">女</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="roleName"
          label="角色"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
<!--        <el-table-column-->
<!--          prop="areaName"-->
<!--          label="所属区域"-->
<!--          min-width="30"-->
<!--          align="center"-->
<!--          :show-overflow-tooltip="true"-->
<!--        ></el-table-column>-->
<!--        <el-table-column-->
<!--          prop="stationName"-->
<!--          label="所属站点"-->
<!--          min-width="30"-->
<!--          align="center"-->
<!--          :show-overflow-tooltip="true"-->
<!--        ></el-table-column>-->
        <el-table-column
          prop="address"
          label="地址"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="40"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'user-edit'"
                  @click="edit(scope.row.id)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #0083fd;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="editBtn"
                  >{{ button.name }}</el-button
                >
                <el-button
                  v-else-if="button.path === 'user-del'"
                  @click="del(scope.row.id)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #c1c1c1;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="delBtn"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 12, 18, 24]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          popper-class="adminHomeSelect"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="44%"
      id="userPage"
      class="commonScrollDialog userPage"
    >
      <div class="scrollContainer">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          @submit.native.prevent
          label-width="100px"
        >
          <div class="rowClass">
            <el-form-item label="用户账号" prop="userNo">
              <el-input
                auto-complete="off"
                v-model="form.userNo"
                placeholder="请填写用户账号(20字内,唯一)"
                maxlength="20"
                class="inputClass"
                clearable
                :disabled="userNoDisable"
                @keyup.enter.native="submit('form')"
              ></el-input>
            </el-form-item>
            <div class="right">
              <el-form-item label="用户名" prop="username">
                <el-input
                  v-model="form.username"
                  placeholder="请填写用户名(20字内)"
                  maxlength="20"
                  class="inputClass"
                  clearable
                  @keyup.enter.native="submit('form')"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="rowClass">
            <el-form-item label="密码" prop="password">
              <el-input
                auto-complete="off"
                v-model="form.password"
                type="password"
                placeholder="请设置密码(不超过32位)"
                maxlength="32"
                class="inputClass"
                clearable
                @keyup.enter.native="submit('form')"
              ></el-input>
            </el-form-item>
            <div class="right">
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input
                  auto-complete="off"
                  v-model="form.confirmPassword"
                  type="password"
                  placeholder="请确认密码(不超过32位)"
                  maxlength="32"
                  class="inputClass"
                  clearable
                  @input="change($event)"
                  @keyup.enter.native="submit('form')"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="rowClass">
            <el-form-item label="昵称" prop="nickname">
              <el-input
                v-model="form.nickname"
                placeholder="请填写昵称(20字内)"
                maxlength="20"
                class="inputClass"
                clearable
                @keyup.enter.native="submit('form')"
              ></el-input>
            </el-form-item>
            <div class="right">
              <el-form-item label="性别" prop="sex">
                <el-select
                  v-model="form.sex"
                  placeholder="请选择性别"
                  class="inputClass"
                  popper-class="adminHomeSelect"
                  clearable
                >
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="rowClass">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请填写手机号(11字内)"
                maxlength="11"
                class="inputClass"
                clearable
                @keyup.enter.native="submit('form')"
              ></el-input>
            </el-form-item>
            <div class="right">
              <el-form-item label="角色" prop="roleId">
                <el-select
                  v-model="form.roleId"
                  @focus="getRoles()"
                  class="inputClass"
                  popper-class="adminHomeSelect"
                  filterable
                  clearable
                  placeholder="请选择所属角色"
                >
                  <el-option label="请选择所属角色" value></el-option>
                  <el-option
                    v-for="item in roles"
                    :key="item.id"
                    :label="item.roleName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="rowClass">
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请填写地址(100字内)"
                maxlength="100"
                class="inputClass"
                clearable
                @keyup.enter.native="submit('form')"
                type="textarea"
                :rows="2"
              ></el-input>
            </el-form-item>
<!--            <el-form-item label="部门" prop="departmentId">-->
<!--              <el-select-->
<!--                v-model="form.departmentId"-->
<!--                @focus="getDepartments()"-->
<!--                class="inputClass"-->
<!--                popper-class="adminHomeSelect"-->
<!--                filterable-->
<!--                clearable-->
<!--                placeholder="请选择所属部门"-->
<!--              >-->
<!--                <el-option label="请选择所属部门" value></el-option>-->
<!--                <el-option-->
<!--                  v-for="item in departments"-->
<!--                  :key="item.id"-->
<!--                  :label="item.name"-->
<!--                  :value="item.id"-->
<!--                ></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <div class="right">

            </div>
          </div>
          <!-- <div class="rowClass">
          <el-form-item label="区块链地址">
            <el-input
              v-model="form.chainAddr"
              placeholder="请填写区块链地址(255字内)"
              maxlength="255"
              class="inputClass"
              clearable
              @keyup.enter.native="submit('form')"
            ></el-input>
          </el-form-item>
          <div class="right">
            <el-form-item label="区块链公钥">
              <el-input
                v-model="form.chainPublicKey"
                placeholder="请填写区块链公钥"
                class="inputClass"
                clearable
                @keyup.enter.native="submit('form')"
              ></el-input>
            </el-form-item>
          </div>
        </div> -->
<!--          <div class="rowClass">-->
<!--            <el-form-item label="地址" prop="address">-->
<!--              <el-input-->
<!--                v-model="form.address"-->
<!--                placeholder="请填写地址(100字内)"-->
<!--                maxlength="100"-->
<!--                class="inputClass"-->
<!--                clearable-->
<!--                @keyup.enter.native="submit('form')"-->
<!--                type="textarea"-->
<!--                :rows="2"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--          </div>-->
          <div class="rowClass avatorClass">
            <el-form-item label="头像">
              <el-upload
                ref="upload"
                action="#"
                :accept="imageType"
                class="avatar-uploader"
                :on-change="onchangeUpload"
                :show-file-list="false"
                :auto-upload="false"
                :disabled="disabled"
              >
                <div v-if="imageUrl">
                  <img :src="imageUrl" class="uploaded-image" />
                  <div
                    title="删除头像"
                    class="deleteButton"
                    @click="handleRemove()"
                  >
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-else class="upload-placeholder">
                  <div class="upload-text">
                    <span>去上传</span>
                  </div>
                </div>
              </el-upload>
              <div class="el-upload__tip">
                注意：只能上传jpg/png文件，且不超过1MB
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div class="formItemBtnRow">
            <el-button
              type="primary"
              @click="submit('form')"
              class="confirmBtn"
              :loading="loading"
              >确 定</el-button
            ><el-button @click="dialogVisible = false" class="cancelBtn"
              >取 消</el-button
            >
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { getAllKey } from "@/assets/js/tree/tree.js";
import BasicForm from "../../../common/BasicForm.vue";


export default {
  name: "user",
  props: ["menuId"],
  data() {
    let validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写密码~"));
      } else {
        if (this.form.confirmPassword) {
          this.$refs.form.validateField("confirmPassword");
        }
        callback();
      }
    };
    let validateConfirmPassword = (rule, value, callback) => {
      value = this.form.confirmPassword;
      if (!value) {
        callback(new Error("请确认密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (value) {
        let regPhone = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/; //11位手机号码正则
        if (!regPhone.test(value)) {
          callback(new Error("手机号格式不正确"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请填写手机号"));
      }
    };
    return {
      loading: false,
      dialogVisible: false,
      title: "添加用户",
      addPermission: null,
      buttonList: [],

      queryForm: {
        keywords: "",
        userNo: "",
        phone: "",
        username: "",
        nickname: "",
        removed: 0,
      },
      form: {
        id: "",
        userNo: "",
        username: "",
        password: "",
        confirmPassword: "",
        phone: "",
        nickname: "",
        iconUrl: "",
        sex: "",
        address: "",
        roleId: "",
        // departmentId: "",
        // areaInfo: "",
        stationId: "",
        chainAddr: "",
        chainPublicKey: "",
        chainPrivateKey: "",
      },
      rules: {
        userNo: [
          { required: true, message: "请填写用户账号", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请填写用户名", trigger: "blur" },
        ],
        password: [
          { required: true, validator: validatePassword, trigger: "blur" },
        ],
        confirmPassword: [
          {
            required: true,
            validator: validateConfirmPassword,
            trigger: "blur",
          },
        ],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        nickname: [{ required: true, message: "请填写昵称", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        address: [{ required: true, message: "请填写地址", trigger: "blur" }],
        roleId: [
          { required: true, message: "请选择所属角色", trigger: "change" },
        ],
        departmentId: [
          { required: true, message: "请选择所属部门", trigger: "change" },
        ],
      },
      disabled: false,
      imageType: "image/jpeg,image/png",
      file: "",
      imageUrl: "",
      roles: [],
      // permission: "", //用户所选角色对应权限id
      // checkedNum: 0,
      // totalTreeNum: 0,
      /* 选项列表数据(树形结构的对象数组) */
      // dataOfTree: [{}],
      // 该数组回显数据根据所对应的ID  进行默认勾选 (:default-checked-keys 这个) 和 (node-key="id") 这个两个并存
      // defaultCheckKeys: [],
      // defaultProps: {
      //   children: "children",
      //   label: "name",
      //   disabled: true,
      // },
      userNoDisable: false,
      departments: [],
      stations: [],
      total: 0, //总条数
      tableData: [],
      current: 1, //当前页数
      size: 6, //显示几条
      tableHeight: 500, // 表格高度
    };
  },
  methods: {
    change(e) {
      this.$forceUpdate();
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    getTableHeight() {
      let tableH = 305; // 除表格外其他区域高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = tableHeightDetil;
      }
    },
    //跳出弹框
    showDialog() {
      this.userNoDisable = false;
      this.dialogVisible = true;
      this.title = "添加用户";
      this.imageUrl = "";
      this.disabled = false;
      this.form = {};
      // this.permission = "";
      // this.getStations();
    },
    getRoles() {
      this.postJsonRequest("/user-server/api/u-role/query?current=1&size=-1", {
        removed: 0,
      }).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          this.roles = data.records;
          // this.getSelectedRoleInfo(this.form.roleId);
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,获取角色失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
        }
      });
    },
    //下拉框选中事件
    getSelectedRoleInfo(id) {
      if (id) {
        let selectedInfo = {};
        selectedInfo = this.roles.find((item) => {
          return item.id === id;
        });
        this.form.roleId = Number(id);
        if (selectedInfo) {
          this.permission = selectedInfo.permission;
        } else {
          this.permission = "";
        }
      } else {
        this.permission = "";
        this.form.roleId = "";
      }
      // this.getPermissionTree();
    },
    //获取权限树
    getPermissionTree() {
      this.postJsonRequest("/user-server/api/u-permission/query", {
        removed: 0,
      }).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          this.dataOfTree = data;
          let dataStr = JSON.stringify(data); //将json对象转换成字符串
          let splitArr = dataStr.split('"name":');
          let len = splitArr.length;
          this.totalTreeNum = len == 0 ? 0 : len - 1;
          let permission = this.permission;
          if (permission) {
            let oldArr = permission.split(",");
            this.checkedNum = oldArr.length;
            this.$refs.tree.setCheckedKeys(
              getAllKey(data, "id", "children", oldArr),
              true
            ); //重点是这句话，将所需要的数据转换成想要的数据
          } else {
            this.checkedNum = 0;
            this.handleCheckAllChange(false);
          }
          if (this.totalTreeNum <= this.checkedNum) {
            this.handleCheckAllChange(false);
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,获取权限失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
        }
      });
    },
    //全选
    handleCheckAllChange(val) {
      if (val) {
        this.$refs.tree.setCheckedNodes(this.systemMenuModeTree);
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    //获取选中和半选中状态下的数据
    handleCheckChange() {
      let res = this.$refs.tree
        .getCheckedNodes()
        .concat(this.$refs.tree.getHalfCheckedNodes());
      let checkedNum = res.length;
      this.checkedNum = checkedNum;
    },
    getDepartments() {
      this.postJsonRequest(
        "/user-server/api/u-department/query?current=1&size=-1",
        { removed: 0 }
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          this.departments = data.records;
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,获取部门失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
        }
      });
    },
    getStations() {
      this.getRequest(
        "/basic-info-server/station/getStationGroupByArea.do"
      ).then((res) => {
        let oData = res.data;
        if (0 === oData.code) {
          let data = oData.data;

          if (!this.isEmptyArray(data)) {
            this.stations = this.resetStation(data);
          } else {
            this.stations = [];
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,获取战区失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
        }
      });
    },
    resetStation(data) {
      if (!this.isEmptyArray(data)) {
        data.forEach((element) => {
          if (!this.isEmptyArray(element.children)) {
            element.children.forEach((e) => {
              e.id = e.id;
              e.value = e.name;
            });
          }
        });
      }
      return data;
    },
    handleChange(selectInfo) {
      if (selectInfo) {
        this.form.stationId = selectInfo[1];
      }
    },
    onchangeUpload(file, fileList) {
      let fileType = this.imageType.split(",");
      if (fileType.indexOf(file.raw.type) >= 0) {
        // 大小限制
        const imageSize = file.size / 1024 / 1024 > 1; //上传图片大小不超过1M
        if (imageSize) {
          let tips =
            "<i class='el-icon-warn-tip'></i>文件大小不能超过1MB";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
          });
          return;
        }
      } else {
        fileList.splice(fileList.length - 1, 1);
        let tips = "<i class='el-icon-warn-tip'></i>只能上传jpg/png文件";
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
        return;
      }
      // 预保存上传的图片
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.iconUrl = "";
      this.file = file;
      this.disabled = true;
    },
    handleRemove() {
      this.imageUrl = "";
      this.file = "";
      this.form.iconUrl = "";
      setTimeout(() => {
        this.disabled = false;
      }, 1000);
    },
    // 提交表单
    submit(formName) {
      try {
        this.loading = true;
        // 进行验证表单内容是否填写正确
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const multiData = this.formatData();
            if (this.form.id) {
              //编辑
              this.update(multiData);
            } else {
              //新增
              this.save(multiData);
            }
          } else {
            return false;
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    formatData() {
      const formData = new FormData();
      const form = {...this.form,departmentId:1};
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          const element = form[key];
          if (null != element && 0 < (element + "").trim().length) {
            formData.append(key, element);
          }
        }
      }
      if (this.file) {
        formData.append("file", this.file.raw);
      }
      return formData;
    },
    // 新增
    save(form) {
      this.uploadFileRequest("/user-server/api/u-user/save", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.imageUrl = "";
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 查询
    query(queryType) {
      try {
        this.loading = true;
        let params = {};
        let current = 1;
        let size = 6;
        if (queryType === "queryById") {
          params = {
            ...this.form,
          };
        } else {
          params = { ...this.queryForm };
          current = this.current;
          size = this.size;
        }
        this.postJsonRequest(
          "/user-server/api/u-user/query?current=" + current + "&size=" + size,
          params
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (queryType === "queryById") {
              this.form = data.records[0];
              this.form.confirmPassword = this.form.password;
              this.form.sex = String(this.form.sex);
              if (this.form.iconUrl) {
                this.imageUrl = "/minio/" + this.form.iconUrl;
                this.disabled = true;
              }
              if (this.form.areaId && this.form.stationId) {
                this.form.areaInfo = [
                  parseInt(this.form.areaId),
                  parseInt(this.form.stationId),
                ];
              }
            } else {
              this.tableData = data.records;
              this.total = data.total;
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    //编辑
    edit(id) {
      this.dialogVisible = true;
      this.title = "编辑用户";
      this.form = {};
      this.form.id = id;
      this.imageUrl = "";
      this.disabled = false;
      this.userNoDisable = true;
      this.query("queryById");
      this.$nextTick(function () {
        // this.getStations();
        this.getDepartments();
        this.getRoles();
      });
    },
    // 编辑
    update(form) {
      this.uploadFilePutRequest("/user-server/api/u-user/update", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.imageUrl = "";
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    //删除
    del(id) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.deleteRequest("/user-server/api/u-user/delete?id=" + id).then(
            (res) => {
              let oData = res.data;
              if (oData.code == 0) {
                let totalPage = Math.ceil((this.total - 1) / this.size);
                let currentPage =
                  this.current > totalPage ? totalPage : this.current;
                this.current = currentPage < 1 ? 1 : currentPage;
                this.query();
                this.$message({
                  message: "删除成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function () {},
                });
              } else if (oData.code != 401) {
                let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
                this.$confirm(tips, "提示", {
                  confirmButtonText: "好的",
                  customClass: "customClass-style",
                  iconClass: "",
                  dangerouslyUseHTMLString: true,
                  confirmButtonClass: "confirm-style",
                  showCancelButton: false,
                });
              }
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "user-add") {
              this.addPermission = child;
            } else if (child.path !== "user-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  created() {
    this.getTableHeight();
  },
  watch: {
    dialogVisible: function (nval, oval) {
      this.defaultClearValidate("form");
    },
  },
};
</script>

<style scoped>
/* 上传图片样式 */
.searchClass{
  cursor: pointer;
  width: 51px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #00aeff;
  line-height: 16px;
  margin-top: 10px;
  border-left: 1px solid #00aeff;
}
.avatar-uploader {
  width: 120px;
  height: 120px;
  background: rgba(10,5,0,0.50);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.uploaded-image {
  max-width: 100%;
  height: auto;
}
.el-upload__tip {
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #fff;
  line-height: 14px;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload-placeholder .upload-text {
  font-size: 16px;
  color: #00AEFF;
}
>>>.el-dialog__header {
    /* background-image: url(../../img/common/tableHead.png); */
    /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
    /* padding: 20px 20px 0px 40px ; */
    background: url(../../../assets/img/2dmap/pop_bg.png)  no-repeat;
    background-position: left bottom;
}
.deleteButton {
  margin-top: -51.5px;
  margin-bottom: 25px;
}
.rowClass {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: auto 30px;
}
.rowClass .right {
  margin-left: -34px;
}

.adminHomeContainer
  .el-tabs
  .el-tabs__content
  .commonScrollDialog
  .el-dialog
  .el-dialog__body
  .el-form
  .rowClass
  .el-form-item {
  /* width: 270px; */
}

.darkAdminHomeContainer
  .el-tabs
  .el-tabs__content
  .commonScrollDialog
  .el-dialog
  .el-dialog__body
  .el-form
  .rowClass
  .el-form-item {
  /* width: 270px; */
}

/* .inputClass {
  width: 270px !important;
} */
/* .labelClass {
  display: flex;
  flex-direction: row;
}
.numClass {
  color: #0083fd;
}
.el-checkbox:last-of-type {
  float: right;
  margin-top: -11px;
}
.treeClass {
  margin: 0 auto;
  margin-top: -35px;
  width: 568px;
  height: 126px;
  background: #ececec;
  border: 1px solid #dadada;
  border-radius: 6px;
  overflow: auto;
}
.el-tree {
  background: transparent;
} */
.avatorClass {
  position: relative;
}
.el-upload__tip {
  position: absolute;
  top: 0%;
  left: 125px;
  width: 300px;
}
</style>




// WEBPACK FOOTER //
// src/components/admin/user/user.vue